import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import { getColumns, getData, getIsLoading } from '../redux/selectors/BalanceonHandRouteSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';
import { BalanceOnHandRouteContainerStyle } from './BalanceonHandRouteContainer.styles';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';

function getTableDownloadTemplate(appContext) {
  switch (appContext) {
  case 'tray':
  case 'bag':
    return 'ROUTE_MANAGEMENT_PAGE_FOR_TRAY_AND_BAG';
  case 'pallet':
  default:
    return 'ROUTE_MANAGEMENT_PAGE_FOR_PALLET_BOX';
  }
}

class BalanceonHandRouteContainer extends Component {
  constructor(props) {
    super(props);
    this.props.tableLoadData(
      {
        tableId: 'ROUTE_MANAGEMENT_PAGE',
      },
      this.props.appContext.appContext,
      {
        impcCodes: [this.props.clickedRow.impc],
        directionRoute: 'BOTH',
      },
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData(
        {
          tableId: 'ROUTE_MANAGEMENT_PAGE',
        },
        this.props.appContext.appContext,
        {
          impcCodes: [this.props.clickedRow.impc],
          directionRoute: 'BOTH',
        },
      );
    }
  }

  render() {
    const {
      appContext: { appContext },
    } = this.props;
    return (
      <BalanceOnHandRouteContainerStyle>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER') || this.props.userRole.includes('IPC_TRAY_MANAGER') || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Link to={{ pathname: 'create-route' }}>
            <Button className="action-buttons">
              Add New Route
            </Button>
          </Link>
        )}
        <ListTable
          listId={TableDefinitions.ROUTE_MANAGEMENT_PAGE.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="id"
          selectCheckbox
          downloadFileTemplate={getTableDownloadTemplate(appContext)}
          downloadType={downloadTypes.EXCEL}
          downloadFileAs="Routes"
        />
      </BalanceOnHandRouteContainerStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

BalanceonHandRouteContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceonHandRouteContainer);
